// Copyright (C) 2021 Bystronic Laser AG

export enum UserType {
  None = 0,

  GlobalAdmin = 10,

  SubsidiaryAdmin = 20,
  CustomerAdmin = 25,
  CustomerUser = 26,

  TechnologyUser = 31,

  ServiceGlobal = 40,
  ServiceUser = 41,
}
